import { render, staticRenderFns } from "./TiersHorseSecondaires.vue?vue&type=template&id=4c5e74d2&"
import script from "./TiersHorseSecondaires.vue?vue&type=script&lang=js&"
export * from "./TiersHorseSecondaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports